export default __webpack_public_path__ + "static/media/Bg.62ec9de7.png";